import {CEU_CMT, PAGEVIEW_TYPE, PRODUCT_TYPE} from "../pages/dashboard/monetization/consts";

/**
 * Currently the API for RPM fetches from publisher revenue + pageview event table
 * whereas for CPM, it fetches from publisher revenue only, which has a different parameters
 * This function converts it based on the metric and product type
 *
 * @param metricType
 * @param productType
 * @param filters
 * @returns {*}
 */
export const convertFilters = (metricType, productType, filters) => {
    const productTypeFilter = productType === CEU_CMT ?
        ['COMMENT_EMBED', 'QUESTION_EMBED'] : ['STANDALONE', 'ANCHOR', 'INTERSTITIAL'];

    const converted = {...filters};
    delete converted[PAGEVIEW_TYPE];
    delete converted[PRODUCT_TYPE];
    converted[metricType] = productTypeFilter;

    return converted
}